"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var HiddenInput_1 = require("./HiddenInput");

var RadioContext = React.createContext(null);
var bounceIn = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(1.05);\n  }\n\n  75% {\n    transform: scale(0.95);\n  }\n\n  100% {\n    transform: scale(1);\n}"], ["\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(1.05);\n  }\n\n  75% {\n    transform: scale(0.95);\n  }\n\n  100% {\n    transform: scale(1);\n}"])));
var RadioButton = styled_components_1.default.span(function (_a) {
  var theme = _a.theme,
      isSelected = _a.isSelected,
      isFocused = _a.isFocused,
      colorOn = _a.colorOn,
      colorOff = _a.colorOff,
      size = _a.size;
  var styles = utils_1.getComponentThemeStyles(theme, 'RadioButton', null, size);
  return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      position: relative;\n      display: inline-flex;\n      border-radius: 50%;\n      background-color: transparent;\n      border: 2px solid ", ";\n      justify-content: center;\n      align-items: center;\n      transition: all 150ms cubic-bezier(0.75, 0, 0.25, 1.25);\n      transform: scale(1);\n\n      &:before, &:after {\n        content: '';\n        position: absolute;\n        border-radius: 50%;\n        transition: all 150ms cubic-bezier(0.75, 0, 0.25, 1.25);\n        transform: scale(0);\n      }\n\n      &:before {\n        box-sizing: content-box;\n        border: 3px solid rgba(4, 90, 159, 0.5);\n        z-index: -1;\n      }\n\n      &:after {\n        background: ", ";\n        box-sizing: border-box;\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n    "], ["\n      position: relative;\n      display: inline-flex;\n      border-radius: 50%;\n      background-color: transparent;\n      border: 2px solid ", ";\n      justify-content: center;\n      align-items: center;\n      transition: all 150ms cubic-bezier(0.75, 0, 0.25, 1.25);\n      transform: scale(1);\n\n      &:before, &:after {\n        content: '';\n        position: absolute;\n        border-radius: 50%;\n        transition: all 150ms cubic-bezier(0.75, 0, 0.25, 1.25);\n        transform: scale(0);\n      }\n\n      &:before {\n        box-sizing: content-box;\n        border: 3px solid rgba(4, 90, 159, 0.5);\n        z-index: -1;\n      }\n\n      &:after {\n        background: ", ";\n        box-sizing: border-box;\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n    "])), theme.colors[colorOff] || colorOff || 'gray', theme.colors[colorOn] || colorOn, isSelected && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          border-color: ", ";\n          transform: scale(1);\n          animation: ", " 150ms 75ms linear;\n\n          &:after {\n            transform: scale(1);\n          }\n        "], ["\n          border-color: ", ";\n          transform: scale(1);\n          animation: ", " 150ms 75ms linear;\n\n          &:after {\n            transform: scale(1);\n          }\n        "])), theme.colors[colorOn] || colorOn, bounceIn), isFocused && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          &:before {\n            transform: scale(1);\n          }\n        "], ["\n          &:before {\n            transform: scale(1);\n          }\n        "]))), styles);
});
var Label = styled_components_1.default.span(function (_a) {
  var theme = _a.theme,
      size = _a.size;
  var styles = utils_1.getComponentThemeStyles(theme, 'RadioLabel', null, size);
  return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-left: 6px;\n    margin-top: 2px;\n    max-width: 300px;\n    text-align: left;\n\n    ", "\n  "], ["\n    margin-left: 6px;\n    margin-top: 2px;\n    max-width: 300px;\n    text-align: left;\n\n    ", "\n  "])), styles);
});
var Container = styled_components_1.default.label(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  user-select: none;\n  display: inline-flex;\n  cursor: pointer;\n  min-height: 30px;\n  justify-content: flex-start;\n  align-items: flex-start;\n\n  &:not(:last-of-type) {\n    margin-right: 10px;\n  }\n\n  &[disabled] {\n    cursor: not-allowed;\n  }\n"], ["\n  user-select: none;\n  display: inline-flex;\n  cursor: pointer;\n  min-height: 30px;\n  justify-content: flex-start;\n  align-items: flex-start;\n\n  &:not(:last-of-type) {\n    margin-right: 10px;\n  }\n\n  &[disabled] {\n    cursor: not-allowed;\n  }\n"])));

function Radio(_a) {
  var label = _a.label,
      inputProps = __rest(_a, ["label"]);

  var _b = React.useContext(RadioContext),
      isSelectedProp = _b.isSelected,
      handleChange = _b.handleChange,
      size = _b.size,
      colorOn = _b.colorOn,
      colorOff = _b.colorOff;

  var name = inputProps.name,
      value = inputProps.value;

  var _c = React.useState(false),
      isFocused = _c[0],
      setFocus = _c[1];

  var matchingId = "RadioGroup__" + name + "-" + value;
  var isSelected = value === isSelectedProp;

  var handleFocus = function handleFocus() {
    setFocus(!isFocused);
  };

  return React.createElement(Container, {
    htmlFor: matchingId
  }, React.createElement(HiddenInput_1.HiddenInput, __assign({
    id: matchingId,
    type: "radio",
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleFocus
  }, inputProps)), React.createElement(RadioButton, {
    isSelected: isSelected,
    isFocused: isFocused,
    colorOn: colorOn,
    colorOff: colorOff,
    size: size
  }), React.createElement(Label, {
    size: size
  }, label));
}

var GroupContainer = styled_components_1.default.div(function (_a) {
  var isHorizontal = _a.isHorizontal;
  return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: inline-flex;\n    flex-direction: column;\n\n    ", "\n  "], ["\n    display: inline-flex;\n    flex-direction: column;\n\n    ", "\n  "])), isHorizontal && styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        flex-direction: row;\n      "], ["\n        flex-direction: row;\n      "]))));
});

function RadioGroup(_a) {
  var choices = _a.choices,
      initialValue = _a.initialValue,
      _b = _a.onChange,
      onChange = _b === void 0 ? function () {
    return {};
  } : _b,
      _c = _a.size,
      size = _c === void 0 ? 'default' : _c,
      _d = _a.isHorizontal,
      isHorizontal = _d === void 0 ? false : _d,
      _e = _a.colorOn,
      colorOn = _e === void 0 ? 'primary' : _e,
      _f = _a.colorOff,
      colorOff = _f === void 0 ? 'gray' : _f,
      className = _a.className,
      inputProps = __rest(_a, ["choices", "initialValue", "onChange", "size", "isHorizontal", "colorOn", "colorOff", "className"]);

  var _g = React.useState(initialValue),
      isSelected = _g[0],
      setSelected = _g[1];

  var handleChange = function handleChange(_a) {
    var _b = _a.target,
        name = _b.name,
        value = _b.value;
    setSelected(value);
    onChange(name, value);
  };

  var context = {
    isSelected: isSelected,
    handleChange: handleChange,
    isHorizontal: isHorizontal,
    size: size,
    colorOn: colorOn,
    colorOff: colorOff
  };
  return React.createElement(GroupContainer, {
    isHorizontal: isHorizontal,
    className: className
  }, React.createElement(RadioContext.Provider, {
    value: context
  }, choices.map(function (choice) {
    return React.createElement(Radio, __assign({
      key: choice.value
    }, choice, inputProps));
  })));
}

exports.RadioGroup = RadioGroup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;